import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MeasurementService } from 'src/app/services/measurement.service';

@Component({
    selector: 'app-bolt-quantity',
    templateUrl: './bolt-quantity.component.html',
    styleUrls: ['./bolt-quantity.component.scss'],
    standalone: false
})
export class BoltQuantityComponent implements OnInit {
    @Input() cssClass;
    @Input() form: UntypedFormGroup;
    tooltip_position = 'above';

    ngOnInit(): void {
        this.form.markAllAsTouched();
    }

    boltQuantityChange($event) {
        this.form.get('boltQuantity').setValue(parseInt($event.target.value));
    }
}
